import Vue from 'vue';

let componentId = 0;
export const getComponentId = () => {
	return (componentId++).toString();
};

export const eventBus = new Vue();

export const openLayer = (e, layerName, props) => {
	e.stopPropagation();

	eventBus.$emit('open-layer', {
		el: e.currentTarget,
		layerName: layerName,
		props: props
	});
};
